<template>
  <div class="ml-3 dr-designer-component-card dr-dc-container-component-designer dr-dc-card">
    <font-awesome-icon :icon="['fal', component.icon]" size="1x"/>
    <div class="dr-dc-card-title">{{component.name}}</div>
  </div>
</template>

<script>
export default {
  props: ['component']
}
</script>

<style lang="scss">
.dr-dc-container-component-designer {
  display: flex;
  align-items: center;
  padding-left: 10px;
}
.dr-dc-card {
  border-radius: 4px;
  background-color: #FFFFFF;
  border-color: #FFFFFF;
  color: rgba(0, 0, 0, 0.87);
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 
              0px 2px 2px 0px rgba(0, 0, 0, 0.14), 
              0px 1px 5px 0px rgba(0, 0, 0, 0.12);
}
.dr-dc-card-title {
  font-size: 14px;
  user-select: none;
  flex-wrap: wrap;
  font-weight: 500;
  letter-spacing: 0.0125em;
  line-height: 2rem;
  word-break: break-all;
  align-items: center;
  -webkit-box-align: center;
  padding: 16px;
}
.dr-designer-component-card {
  height: 35px;
  display: flex;
  align-items: center;
}
</style>
